export const formatPrice = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === "") return "";
  const raw = typeof value === "number"
    ? value
    : parseFloat(String(value).replace(/\./g, "").replace(/\s/g, "").replace(",", "."));
  if (isNaN(raw)) return String(value);
  return raw.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};
